export const messages = {
  en: {
    itemReleaseDetail: {
      releaseDetails: 'Release Details',
      back: 'Back',
      applyCompany: 'Application Unit:',
      passType: 'Pass Type:',
      applicant: 'Applicant:',
      idCard: 'ID Card:',
      phone: 'Phone:',
      applyTime: 'Application Time:',
      status: 'Status:',
      licensePlate: 'License Plate:',
      passTime: 'Pass Time:',
      totalQuantity: 'Total Quantity:',
      releaseItems: 'Release Items',
      itemName: 'Item Name',
      quantity: 'Quantity',
      workflowProcess: 'Workflow Process',
      serialNumber: 'No.',
      department: 'Department',
      handler: 'Handler',
      processed: 'Processed',
      processing: 'Processing',
      timeConsumed: 'Time Consumed',
      comment: 'Comment',
      workOrderProcessing: 'Work Order Processing',
      action: 'Action',
      pleaseSelect: 'Please Select',
      agree: 'Agree',
      return: 'Return',
      returnToSubmitter: 'Return to Submitter',
      transfer: 'Transfer',
      workOrderDescription: 'Work Order Description',
      requiredDescription: 'Required, please fill in work order description',
      nextHandler: 'Next Handler',
      requiredNextHandler: 'Required, please select next handler',
      select: 'Select',
      submit: 'Submit',
      flowChart: 'Flow Chart',
      illegalOperation: 'Illegal operation',
      selectStatus: 'Please select status',
      fillDescription: 'Please fill in description',
      selectNextHandler: 'Please select next handler',
      submitSuccess: 'Submit successfully',
      submitFailed: 'Submit failed',
      administrator: 'Administrator',
      end: 'End'
    }
  },
  zh: {
    itemReleaseDetail: {
      releaseDetails: '放行详情',
      back: '返回',
      applyCompany: '申请单位：',
      passType: '通行类型：',
      applicant: '申请人：',
      idCard: '身份证：',
      phone: '手机号：',
      applyTime: '申请时间：',
      status: '状态：',
      licensePlate: '车牌号：',
      passTime: '通行时间：',
      totalQuantity: '物品总数量：',
      releaseItems: '放行物品',
      itemName: '物品名称',
      quantity: '数量',
      workflowProcess: '工单流转',
      serialNumber: '序号',
      department: '部门',
      handler: '处理人',
      processed: '处理完成',
      processing: '正在处理',
      timeConsumed: '耗时',
      comment: '意见',
      workOrderProcessing: '工单办理',
      action: '动作',
      pleaseSelect: '请选择',
      agree: '同意',
      return: '退回',
      returnToSubmitter: '退回至提交者',
      transfer: '转单',
      workOrderDescription: '工单说明',
      requiredDescription: '必填，请填写工单说明',
      nextHandler: '下一处理人',
      requiredNextHandler: '必填，请选择下一处理人',
      select: '选择',
      submit: '提交',
      flowChart: '流程图',
      illegalOperation: '非法操作',
      selectStatus: '请选择状态',
      fillDescription: '请填写说明',
      selectNextHandler: '请选择下一节点处理人',
      submitSuccess: '提交成功',
      submitFailed: '提交失败',
      administrator: '管理员',
      end: '结束'
    }
  }
}